import React, { useState } from "react";
import styled from "styled-components";
import { db } from "../../firebase/firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Save } from "lucide-react";

const AddInterviewPrep = () => {
  const navigate = useNavigate();
  const [profile, setProfile] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  const techProfiles = [
    "React Native Developer",
    "Frontend Developer",
    "Backend Developer",
    "Full Stack Developer",
    "Android Developer (Kotlin)",
    "iOS Developer (Swift)",
    "Data Scientist",
    "Machine Learning Engineer",
    "DevOps Engineer",
    "UI/UX Designer",
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!profile) {
      alert("Please select a tech profile!");
      return;
    }

    setLoading(true);
    try {
      await addDoc(collection(db, "interviewPreps"), {
        title: profile,
        category: profile,
        description: description || "",
        createdAt: serverTimestamp(),
      });
      alert("✅ Interview Prep added successfully!");
      navigate("/admin-panel");
    } catch (err) {
      console.error(err);
      alert("❌ Error adding interview prep");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Wrapper>
      <Header>
        <BackButton onClick={() => navigate("/admin")}>
          <ArrowLeft size={18} /> Back to Admin
        </BackButton>
        <h2>Add Interview Prep</h2>
      </Header>

      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Label>Select Profile (Tech Field)</Label>
          <Select
            value={profile}
            onChange={(e) => setProfile(e.target.value)}
            required
          >
            <option value="">-- Choose a profile --</option>
            {techProfiles.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </Select>
        </FormGroup>

        <FormGroup>
          <Label>Description (Optional)</Label>
          <Textarea
            rows="5"
            placeholder="Write about the interview prep or question set..."
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </FormGroup>

        <SubmitButton type="submit" disabled={loading}>
          {loading ? (
            "Saving..."
          ) : (
            <>
              <Save size={18} /> Submit Prep
            </>
          )}
        </SubmitButton>
      </Form>
    </Wrapper>
  );
};

export default AddInterviewPrep;

// ===================== STYLED COMPONENTS =====================

const Wrapper = styled.div`
  min-height: 100vh;
  background: radial-gradient(circle at top left, #0b0617, #000);
  padding: 40px;
  color: #fff;
  font-family: "Inter", sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.div`
  width: 100%;
  max-width: 700px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 40px;

  h2 {
    font-size: 1.8rem;
    font-weight: 700;
    background: linear-gradient(90deg, #9b5cff, #c59fff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

const BackButton = styled.button`
  background: rgba(155, 92, 255, 0.1);
  border: 1px solid rgba(155, 92, 255, 0.4);
  color: #c59fff;
  border-radius: 8px;
  padding: 8px 12px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: 0.3s;
  &:hover {
    background: rgba(155, 92, 255, 0.2);
  }
`;

const Form = styled.form`
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(155, 92, 255, 0.3);
  border-radius: 16px;
  padding: 30px;
  width: 100%;
  max-width: 700px;
  backdrop-filter: blur(8px);
  box-shadow: 0 0 15px rgba(155, 92, 255, 0.2);
`;

const FormGroup = styled.div`
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  color: #c59fff;
  margin-bottom: 8px;
  font-weight: 600;
`;

const Select = styled.select`
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid rgba(155, 92, 255, 0.3);
  background: rgba(20, 10, 35, 0.9);
  color: #fff;
  font-size: 1rem;
  outline: none;
  &:focus {
    border-color: #c59fff;
  }
`;

const Textarea = styled.textarea`
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid rgba(155, 92, 255, 0.3);
  background: rgba(20, 10, 35, 0.9);
  color: #fff;
  resize: none;
  font-size: 1rem;
  outline: none;
  &:focus {
    border-color: #c59fff;
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  background: linear-gradient(90deg, #9b5cff, #c59fff);
  border: none;
  color: white;
  padding: 14px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  font-size: 1rem;
  transition: 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    box-shadow: 0 0 20px rgba(155, 92, 255, 0.4);
    transform: translateY(-2px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
